import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PLinkModule } from '@panaya/ui/p-link';
import { PButtonModule } from '@panaya/ui/p-button';
import { PGuideMeButtonComponent } from './p-guide-me-button.component';

@NgModule({
    declarations: [PGuideMeButtonComponent],
    imports: [PLinkModule, PButtonModule, MatTooltipModule],
    exports: [PGuideMeButtonComponent]
})
export class PGuideMeButtonModule {}
